(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    if (window.__ygMainCollectionSidebarToggleInitialized) {
      return;
    }

    window.__ygMainCollectionSidebarToggleInitialized = true;

    const desktopMediaQuery = window.matchMedia('(min-width: 1000px)');

    const getSidebarStateKey = (section) => {
      return `yg-main-collection-sidebar:v2:${section.id}:${window.location.pathname}`;
    };

    const dispatchSingleSelectProductTypeFilter = (section, button) => {
      if (!section || !button) {
        return;
      }

      const paramName = button.dataset.ygProductTypeFilterParam;
      const value = button.dataset.ygProductTypeFilterValue;

      if (!paramName) {
        return;
      }

      const url = new URL(window.location.href);
      const sectionId = section.id.replace('shopify-section-', '');

      url.searchParams.delete('page');
      url.searchParams.delete(paramName);

      if (!button.classList.contains('active') && value) {
        url.searchParams.append(paramName, value);
      }

      url.searchParams.set('section_id', sectionId);

      section.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: {
          url
        }
      }));
    };

    const updateToggleButton = (collection, isCollapsed) => {
      const toggleButton = collection.querySelector('.collection__facets-toggle');

      if (!toggleButton) {
        return;
      }

      const toggleLabel = toggleButton.querySelector('.collection__facets-toggle-label');

      if (toggleLabel) {
        toggleLabel.textContent = isCollapsed ? toggleButton.dataset.showLabel : toggleButton.dataset.hideLabel;
      }

      toggleButton.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
    };

    const applySidebarState = (section) => {
      const collection = section.querySelector('.collection--filters-sidebar');

      if (!collection || !collection.querySelector('.collection__facets')) {
        return;
      }

      let isCollapsed = collection.classList.contains('collection--facets-hidden');

      try {
        const storedState = sessionStorage.getItem(getSidebarStateKey(section));

        if (storedState == 'expanded') {
          isCollapsed = false;
        } else if (storedState == 'collapsed') {
          isCollapsed = true;
        }
      } catch (error) {
      }

      collection.classList.toggle('collection--facets-hidden', isCollapsed);
      updateToggleButton(collection, isCollapsed);
    };

    const applySidebarStateToAllSections = () => {
      document.querySelectorAll('.shopify-section--main-collection').forEach((section) => {
        applySidebarState(section);
      });
    };

    applySidebarStateToAllSections();

    document.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('.collection__facets-toggle');

      if (!toggleButton || !desktopMediaQuery.matches) {
        return;
      }

      const collection = toggleButton.closest('.collection');

      if (!collection || !collection.classList.contains('collection--filters-sidebar')) {
        return;
      }

      if (!collection.querySelector('.collection__facets')) {
        return;
      }

      const isCollapsed = collection.classList.toggle('collection--facets-hidden');

      updateToggleButton(collection, isCollapsed);

      try {
        sessionStorage.setItem(getSidebarStateKey(collection.closest('.shopify-section')), isCollapsed ? 'collapsed' : 'expanded');
      } catch (error) {
      }
    });

    document.addEventListener('click', (event) => {
      const productTypeButton = event.target.closest('.yg-collection-jump[data-yg-product-type-filter-param]');

      if (!productTypeButton) {
        return;
      }

      const section = productTypeButton.closest('.shopify-section--main-collection');

      if (!section) {
        return;
      }

      dispatchSingleSelectProductTypeFilter(section, productTypeButton);
    });

    document.addEventListener('facet:update', (event) => {
      const section = event.target.closest('.shopify-section--main-collection');

      if (!section) {
        return;
      }

      let attempts = 0;

      const syncSidebarState = () => {
        if (!section.classList.contains('is-loading')) {
          applySidebarState(section);
          return;
        }

        attempts += 1;

        if (attempts < 30) {
          requestAnimationFrame(syncSidebarState);
        }
      };

      requestAnimationFrame(syncSidebarState);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const isSkuSearchQuery = (query) => /^[A-Za-z0-9][A-Za-z0-9._/-]*$/.test(query) && /[A-Za-z]/.test(query) && /\d/.test(query);
    const escapeSearchSyntaxValue = (query) => `"${query.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-enable-sku-submit-rewrite]');

      if (!form) {
        return;
      }

      const queryInput = form.elements.q;

      if (!queryInput) {
        return;
      }

      const trimmedQuery = queryInput.value.trim();

      if (trimmedQuery === '' || !isSkuSearchQuery(trimmedQuery)) {
        queryInput.value = trimmedQuery;
        return;
      }

      queryInput.value = `${trimmedQuery} OR variants.sku:${escapeSearchSyntaxValue(trimmedQuery)}`;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordionVideo01 extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }

      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) return;

        const mobileSpaceBetween = Number(this.dataset.mobileSpaceBetween || 12);

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: mobileSpaceBetween,
          slidesPerView: 1,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          autoHeight: true,
          pagination: {
            el: '.yg-accordion-pagination',
            clickable: true,
          },
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
        });

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 700;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 延迟初始化轮播，确保DOM已准备好
            setTimeout(() => this.initSwiper(), 50);
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-accordion-video-01')) {
      window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGBannerTabs01 extends HTMLElement {
      constructor() {
        super();
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'tabs-container': this.querySelector('.yg-tabs-title-container'),
          'tabs': this.querySelectorAll('.yg-banner-tab-title'),
          'swiper': this.querySelector(".yg-banner-swiper")
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        // 获取swiper元素
        if (this.sectionsEl['swiper']&&this.sectionsEl['tabs-container']) {
          this.sectionsEl['swiper'].swiper.on('slideChange', (e) => {
            let realIndex = e.realIndex;
            this.sectionsEl['tabs-container'].toggleClass(this.sectionsEl['tabs'][realIndex], realIndex)
          });
        }
        if (this.sectionsEl['tabs']) {
          this.sectionsEl['tabs'].forEach((tab, index) => {
            tab.addEventListener('click', () => this.sectionsEl['swiper'].swiper.slideToLoop(index))
          });
        }
        
      }
    }
    if (!customElements.get('yg-banner-tabs-01')) {
      customElements.define('yg-banner-tabs-01', YGBannerTabs01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGBannerTabs01 extends HTMLElement {
      constructor() {
        super();
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'tabs-container': this.querySelector('.yg-tabs-title-container'),
          'tabs': this.querySelectorAll('.yg-banner-tab-title'),
          'swiper': this.querySelector(".yg-banner-swiper")
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        // 获取swiper元素
        if (this.sectionsEl['swiper']&&this.sectionsEl['tabs-container']) {
          this.sectionsEl['swiper'].swiper.on('slideChange', (e) => {
            let realIndex = e.realIndex;
            this.sectionsEl['tabs-container'].toggleClass(this.sectionsEl['tabs'][realIndex], realIndex)
          });
        }
        if (this.sectionsEl['tabs']) {
          this.sectionsEl['tabs'].forEach((tab, index) => {
            tab.addEventListener('click', () => this.sectionsEl['swiper'].swiper.slideToLoop(index))
          });
        }
        
      }
    }
    if (!customElements.get('yg-banner-tabs-01')) {
      customElements.define('yg-banner-tabs-01', YGBannerTabs01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-info-card-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGImageInfoCard extends HTMLElement {
      constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.updateScrollbar = this.updateScrollbar.bind(this);
      }

      connectedCallback() {
        this.$body = this.querySelector('.yg-image-info-card__body');
        this.$items = this.querySelector('.yg-image-info-card__items');
        this.$track = this.querySelector('.yg-image-info-card__fake-scrollbar');
        this.$thumb = this.querySelector('.yg-image-info-card__fake-scrollbar-thumb');

        if (!this.$body || !this.$items || !this.$track || !this.$thumb) {
          return;
        }

        this.$items.addEventListener('scroll', this.handleScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(() => {
          this.updateScrollbar();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.$items);

        this.mutationObserver = new MutationObserver(() => {
          this.updateScrollbar();
        });
        this.mutationObserver.observe(this.$items, { childList: true, subtree: true, characterData: true });

        window.addEventListener('load', this.updateScrollbar);
        requestAnimationFrame(this.updateScrollbar);
      }

      disconnectedCallback() {
        if (this.$items) {
          this.$items.removeEventListener('scroll', this.handleScroll);
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }

        window.removeEventListener('load', this.updateScrollbar);
      }

      handleScroll() {
        this.updateScrollbar();
      }

      updateScrollbar() {
        if (!this.$body || !this.$items || !this.$track || !this.$thumb) {
          return;
        }

        const viewportHeight = this.$items.clientHeight;
        const contentHeight = this.$items.scrollHeight;
        const maxScroll = Math.max(contentHeight - viewportHeight, 0);
        const hasScrollableContent = maxScroll > 1;

        this.$body.classList.toggle('is-scrollable', hasScrollableContent);

        if (!hasScrollableContent) {
          this.$thumb.style.height = '0px';
          this.$thumb.style.transform = 'translateY(0)';
          return;
        }

        const trackHeight = this.$track.clientHeight;

        if (!trackHeight) {
          requestAnimationFrame(this.updateScrollbar);
          return;
        }

        const thumbHeight = Math.max(trackHeight * (viewportHeight / contentHeight), 48);
        const maxThumbOffset = Math.max(trackHeight - thumbHeight, 0);
        const progress = maxScroll ? this.$items.scrollTop / maxScroll : 0;

        this.$thumb.style.height = `${thumbHeight}px`;
        this.$thumb.style.transform = `translateY(${maxThumbOffset * progress}px)`;
      }
    }

    if (!window.customElements.get('yg-image-info-card')) {
      window.customElements.define('yg-image-info-card', YGImageInfoCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGNav extends YGUtils {
      #sectionsEl;

      constructor() {
        super();
        this.observer = null;
        this.visibleAtc = new Set();
        this.boundOnVariantChange = this.onVariantChange.bind(this);
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      }

      get $sectionsEl() {
        if (this.#sectionsEl) return this.#sectionsEl;
        this.#sectionsEl = {
          atcForm:
            document.querySelector('product-info [is="product-form"]') ||
            document.querySelector('product-rerender [is="product-form"]'),
          sectionEl: this.closest('.shopify-section'),
          topBar: this.querySelector('.yg-nav-top'),
          bottomBar: this.querySelector('.yg-nav-bottom'),
        };
        return this.#sectionsEl;
      }

      connectedCallback() {
        this.observeAtcForm();
        this.syncVisibilityState();
        document.addEventListener('variant:change', this.boundOnVariantChange);
        this.addEventListener('click', this.boundOnClick);
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        document.addEventListener('click', this.boundOnDocumentClick);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        document.removeEventListener('variant:change', this.boundOnVariantChange);
        this.removeEventListener('click', this.boundOnClick);
        window.removeEventListener('scroll', this.boundOnScroll);
        document.removeEventListener('click', this.boundOnDocumentClick);
      }

      setActiveState(isActive) {
        const isNavActive = isActive && window.scrollY > 1500;

        if (isNavActive) {
          this.$sectionsEl.sectionEl?.classList.add('active');
          this.$sectionsEl.topBar?.classList.add('active');
        } else {
          this.$sectionsEl.sectionEl?.classList.remove('active');
          this.$sectionsEl.topBar?.classList.remove('active');
        }

        if (isNavActive) {
          this.$sectionsEl.bottomBar?.classList.add('active');
        } else {
          this.$sectionsEl.bottomBar?.classList.remove('active');
        }
      }

      syncVisibilityState() {
        const atcForm = this.$sectionsEl.atcForm;
        if (!atcForm) return;

        const rect = atcForm.getBoundingClientRect();
        const hasPassedAtc = rect.bottom <= 0;
        this.setActiveState(hasPassedAtc);
      }

      onScroll() {
        this.syncVisibilityState();
      }

      onDocumentClick(event) {
        const openedDetails = this.querySelector('.yg-nav-variant-dropdown[open]');
        if (!openedDetails) return;

        const isClickInsideDropdown = event.target.closest('.yg-nav-variant-dropdown');
        if (!isClickInsideDropdown) {
          openedDetails.removeAttribute('open');
        }
      }

      observeAtcForm() {
        if (!this.$sectionsEl.atcForm || !this.$sectionsEl.bottomBar) return;
        if (this.observer) this.observer.disconnect();

        this.observer = new IntersectionObserver(
          () => {
            this.syncVisibilityState();
          },
          {
            root: null,
            threshold: 0.1,
          }
        );

        this.observer.observe(this.$sectionsEl.atcForm);
      }

      onVariantChange() {
        this.visibleAtc.clear();
        this.#sectionsEl = null;
        this.observeAtcForm();
        this.syncVisibilityState();

        this.getLatestDom((html) => {
          const sectionEl = this.closest('.shopify-section');
          if (!sectionEl) return;
          const latestBar = html.querySelector(`#${sectionEl.id} .yg-nav-bottom`);
          const currentBar = this.querySelector('.yg-nav-bottom');
          if (latestBar && currentBar) {
            currentBar.replaceWith(latestBar.cloneNode(true));
            this.#sectionsEl = null;
            this.observeAtcForm();
            this.syncVisibilityState();
          }
        });
      }

      onClick(event) {
        const addToCart = event.target.closest('.yg-nav-button-add');
        const buyNow = event.target.closest('.yg-nav-button-buy');
        const variantOption = event.target.closest('.yg-nav-variant-option');

        if (variantOption) {
          this.selectVariant(variantOption);
          return;
        }

        if (addToCart) {
          const addToCartButton =
            document.querySelector('product-info product-form [type="submit"]') ||
            document.querySelector('product-rerender product-form [type="submit"]') ||
            document.querySelector('product-info [is="product-form"] [type="submit"]') ||
            document.querySelector('product-rerender [is="product-form"] [type="submit"]');
          if (addToCartButton) addToCartButton.click();
        }

        if (buyNow) {
          const buyNowButton =
            document.querySelector('product-info .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-info shopify-buy-it-now-button .shopify-payment-button__button') ||
            document.querySelector('product-rerender .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-rerender shopify-buy-it-now-button .shopify-payment-button__button');
          if (buyNowButton) buyNowButton.click();
        }
      }

      selectVariant(variantOption) {
        const selectedTitle = variantOption.getAttribute('data-variant-title');
        const selectedId = variantOption.getAttribute('data-variant-id');
        if (!selectedTitle) return;

        const optionsText = selectedTitle.split('/').map((item) => item.trim());
        const forms = document.querySelectorAll('.variant-picker fieldset.variant-picker__option');
        let isSelectedFromLabels = false;

        if (forms.length > 0) {
          forms.forEach((form) => {
            const labels = form.querySelectorAll('label');
            labels.forEach((label) => {
              optionsText.forEach((text) => {
                const span = label.querySelector('span');
                if (span && span.innerText === text) {
                  label.click();
                  isSelectedFromLabels = true;
                }
              });
            });
          });
        }

        if (!isSelectedFromLabels && selectedId) {
          const idInput =
            document.querySelector('product-info [is="product-form"] [name="id"]') ||
            document.querySelector('product-rerender [is="product-form"] [name="id"]');
          if (idInput) {
            idInput.value = selectedId;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const currentTitle = this.querySelector('.yg-nav-variant-current');
        if (currentTitle) {
          currentTitle.textContent = selectedTitle;
        }

        this.querySelectorAll('.yg-nav-variant-option').forEach((item) => {
          item.classList.toggle('active', item === variantOption);
        });

        const details = variantOption.closest('.yg-nav-variant-dropdown');
        if (details) {
          details.removeAttribute('open');
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          this.syncVisibilityState();
        }, 420);
      }
    }

    if (!window.customElements.get('yg-nav')) {
      window.customElements.define('yg-nav', YGNav);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-page-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGNav extends YGUtils {
      #sectionsEl;

      constructor() {
        super();
        this.observer = null;
        this.visibleAtc = new Set();
        this.boundOnVariantChange = this.onVariantChange.bind(this);
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      }

      get $sectionsEl() {
        if (this.#sectionsEl) return this.#sectionsEl;
        this.#sectionsEl = {
          atcForm:
            document.querySelector('product-info [is="product-form"]') ||
            document.querySelector('product-rerender [is="product-form"]'),
          sectionEl: this.closest('.shopify-section'),
          topBar: this.querySelector('.yg-nav-top'),
          bottomBar: this.querySelector('.yg-nav-bottom'),
        };
        return this.#sectionsEl;
      }

      connectedCallback() {
        this.observeAtcForm();
        this.syncVisibilityState();
        document.addEventListener('variant:change', this.boundOnVariantChange);
        this.addEventListener('click', this.boundOnClick);
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        document.addEventListener('click', this.boundOnDocumentClick);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        document.removeEventListener('variant:change', this.boundOnVariantChange);
        this.removeEventListener('click', this.boundOnClick);
        window.removeEventListener('scroll', this.boundOnScroll);
        document.removeEventListener('click', this.boundOnDocumentClick);
      }

      setActiveState(isActive) {
        if (isActive) {
          this.$sectionsEl.sectionEl?.classList.add('active');
          this.$sectionsEl.topBar?.classList.add('active');
          this.$sectionsEl.bottomBar?.classList.add('active');
        } else {
          this.$sectionsEl.sectionEl?.classList.remove('active');
          this.$sectionsEl.topBar?.classList.remove('active');
          this.$sectionsEl.bottomBar?.classList.remove('active');
        }
      }

      syncVisibilityState() {
        const atcForm = this.$sectionsEl.atcForm;
        if (!atcForm) return;

        const rect = atcForm.getBoundingClientRect();
        const hasPassedAtc = rect.bottom <= 0;
        this.setActiveState(hasPassedAtc);
      }

      onScroll() {
        this.syncVisibilityState();
      }

      onDocumentClick(event) {
        const openedDetails = this.querySelector('.yg-nav-variant-dropdown[open]');
        if (!openedDetails) return;

        const isClickInsideDropdown = event.target.closest('.yg-nav-variant-dropdown');
        if (!isClickInsideDropdown) {
          openedDetails.removeAttribute('open');
        }
      }

      observeAtcForm() {
        if (!this.$sectionsEl.atcForm || !this.$sectionsEl.bottomBar) return;
        if (this.observer) this.observer.disconnect();

        this.observer = new IntersectionObserver(
          () => {
            this.syncVisibilityState();
          },
          {
            root: null,
            threshold: 0.1,
          }
        );

        this.observer.observe(this.$sectionsEl.atcForm);
      }

      onVariantChange() {
        this.visibleAtc.clear();
        this.#sectionsEl = null;
        this.observeAtcForm();
        this.syncVisibilityState();

        this.getLatestDom((html) => {
          const sectionEl = this.closest('.shopify-section');
          if (!sectionEl) return;
          const latestBar = html.querySelector(`#${sectionEl.id} .yg-nav-bottom`);
          const currentBar = this.querySelector('.yg-nav-bottom');
          if (latestBar && currentBar) {
            currentBar.replaceWith(latestBar.cloneNode(true));
            this.#sectionsEl = null;
            this.observeAtcForm();
            this.syncVisibilityState();
          }
        });
      }

      onClick(event) {
        const addToCart = event.target.closest('.yg-nav-button-add');
        const buyNow = event.target.closest('.yg-nav-button-buy');
        const variantOption = event.target.closest('.yg-nav-variant-option');

        if (variantOption) {
          this.selectVariant(variantOption);
          return;
        }

        if (addToCart) {
          const addToCartButton =
            document.querySelector('product-info product-form [type="submit"]') ||
            document.querySelector('product-rerender product-form [type="submit"]') ||
            document.querySelector('product-info [is="product-form"] [type="submit"]') ||
            document.querySelector('product-rerender [is="product-form"] [type="submit"]');
          if (addToCartButton) addToCartButton.click();
        }

        if (buyNow) {
          const buyNowButton =
            document.querySelector('product-info .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-info shopify-buy-it-now-button .shopify-payment-button__button') ||
            document.querySelector('product-rerender .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-rerender shopify-buy-it-now-button .shopify-payment-button__button');
          if (buyNowButton) buyNowButton.click();
        }
      }

      selectVariant(variantOption) {
        const selectedTitle = variantOption.getAttribute('data-variant-title');
        const selectedId = variantOption.getAttribute('data-variant-id');
        if (!selectedTitle) return;

        const optionsText = selectedTitle.split('/').map((item) => item.trim());
        const forms = document.querySelectorAll('.variant-picker fieldset.variant-picker__option');
        let isSelectedFromLabels = false;

        if (forms.length > 0) {
          forms.forEach((form) => {
            const labels = form.querySelectorAll('label');
            labels.forEach((label) => {
              optionsText.forEach((text) => {
                const span = label.querySelector('span');
                if (span && span.innerText === text) {
                  label.click();
                  isSelectedFromLabels = true;
                }
              });
            });
          });
        }

        if (!isSelectedFromLabels && selectedId) {
          const idInput =
            document.querySelector('product-info [is="product-form"] [name="id"]') ||
            document.querySelector('product-rerender [is="product-form"] [name="id"]');
          if (idInput) {
            idInput.value = selectedId;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const currentTitle = this.querySelector('.yg-nav-variant-current');
        if (currentTitle) {
          currentTitle.textContent = selectedTitle;
        }

        this.querySelectorAll('.yg-nav-variant-option').forEach((item) => {
          item.classList.toggle('active', item === variantOption);
        });

        const details = variantOption.closest('.yg-nav-variant-dropdown');
        if (details) {
          details.removeAttribute('open');
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          this.syncVisibilityState();
        }, 420);
      }
    }

    if (!window.customElements.get('yg-nav')) {
      window.customElements.define('yg-nav', YGNav);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-specification"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('.yg-specification-main[data-rows-desktop]').forEach((grid) => {
        if (grid.specificationCleanup) return;
        const button = grid.parentElement.querySelector('yg-collapse-button');
        const update = () => {
          const items = Array.from(grid.children);
          const mobile = window.matchMedia('(max-width: 699px)').matches;
          const rows = Number(mobile ? grid.dataset.rowsMobile : grid.dataset.rowsDesktop);
          const columns = mobile ? 2 : 3;
          const visible = items.slice(0, rows * columns);
          const top = grid.getBoundingClientRect().top;
          const height = visible.reduce((bottom, item) => Math.max(bottom, item.getBoundingClientRect().bottom - top), 0);
          grid.style.setProperty('--spec-collapsed-height', `${height}px`);
          if (button) button.style.display = items.length <= rows * columns ? 'none' : '';
        };
        const observer = new ResizeObserver(update);
        Array.from(grid.children).forEach((item) => observer.observe(item));
        window.addEventListener('resize', update);
        grid.specificationCleanup = () => {
          observer.disconnect();
          window.removeEventListener('resize', update);
        };
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.yg-specification-main').forEach((grid) => grid.specificationCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGIimelineSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      // 初始化图片 swiper
      this.imagesSwiperEl = this.querySelector('.yg-timeline-images-swiper');
      this.contentSwiperEl = this.querySelector('.yg-timeline-swiper');
      this.prevBtn = this.querySelector('.swiper-button-prev');
      this.nextBtn = this.querySelector('.swiper-button-next');

      // 创建图片 swiper 实例
      this.imagesSwiperInstance = new Swiper(this.imagesSwiperEl, {
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "fade",
      });

      // 创建内容 swiper 实例
      this.contentSwiperInstance = new Swiper(this.contentSwiperEl, {
        spaceBetween: 12,
        slidesPerView: 1,
        breakpoints: {
          700: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
        },
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        controller: {
          control: this.imagesSwiperInstance,
        },
        on: {
          slideChange: (e) => {
            if(e.activeIndex ===e.slides.length - 3) {
              
              this.slidesElTransformValue = e.slidesEl.style.transform;
              e.slidesEl.style.setProperty('--transform', this.slidesElTransformValue);
            }

             if(e.activeIndex >= e.slides.length - 2) {
              e.slidesEl.classList.add('yg-slides-el-transform');
              
             } else {
              e.slidesEl.classList.remove('yg-slides-el-transform');
             }
          },
        },
      });

      // 设置双向控制
      this.imagesSwiperInstance.controller.control = this.contentSwiperInstance;
    }

  }

  if (!customElements.get('yg-timeline-swiper')) {
    customElements.define('yg-timeline-swiper', YGIimelineSwiper);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoList01 extends HTMLElement {
      constructor() {
        super();
        this.playbackMode = this.getAttribute('data-playback-mode');
        this.slideItems = this.querySelectorAll('.yg-slide-item');
        this.handleClickPlayback = this.handleClickPlayback.bind(this);
      }
      connectedCallback() {
        if (this.playbackMode === 'click') {
          this.addEventListener('click', this.handleClickPlayback, true);
        }

        if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
          this.initHoverPlayback();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClickPlayback, true);
      }

      handleClickPlayback(event) {
        const target = event.target instanceof Element ? event.target : null;
        const playButton = target ? target.closest('.yg-play') : null;
        if (!playButton || !this.contains(playButton)) return;

        const currentVideo = playButton.closest('yg-video');
        if (!currentVideo || !this.contains(currentVideo)) return;

        this.pauseOtherVideos(currentVideo);
      }

      pauseOtherVideos(currentVideo) {
        this.querySelectorAll('yg-video').forEach((videoEl) => {
          if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
          videoEl.pauseVideo();
        });
      }

      initHoverPlayback() {
        this.slideItems.forEach((item) => {
          const videoEl = item.querySelector('yg-video');
          if (!videoEl) return;

          item.addEventListener('mouseenter', () => {
            if (videoEl.playVideo) {
              videoEl.playVideo();
            }
          });

          item.addEventListener('mouseleave', () => {
            if (videoEl.pauseVideo) {
              videoEl.pauseVideo();
            }
          });
        });
      }
    }
    if (!window.customElements.get('yg-video-list-01')) {
      window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
